import { css } from 'styled-components';

export const BorderRadiusRight = css`
    border-radius: 0 8px 8px 0;
`;
export const BorderRadiusLeft = css`
    border-radius: 8px 0px 0px 8px;
`;
export const BorderRadiusTop = css`
    border-radius: 8px 8px 0 0;
`;
export const BorderRadiusBottom = css`
    border-radius: 0 0 8px 8px;
`;
